import { NavBarNames } from "./NavBarNameList";

// home breadcrumb
export const homeBreads = () => {
  return [{ name: 'Home', link: '/' }];
};

//campaign breadcrumb
export const campaignListBreads = () => {
  const homeBreadList = homeBreads();
  homeBreadList.push({ name: 'Campaigns', link: '/campaigns' });
  return homeBreadList;
};

export const createCampaignBreads = (bread) => {
  const camapignListBreadList = campaignListBreads();
  camapignListBreadList.push({
    name: `${bread ? bread : 'Create Campaign'}`,
    link: '/campaigns/create',
  });
  return camapignListBreadList;
};

export const editCampaignBreads = () => {
  const camapignListBreadList = campaignListBreads();
  camapignListBreadList.push({
    name: 'Edit Campaign',
  });
  return camapignListBreadList;
};

// stamp campaign
export const stampCampaignListBreads = () => {
  const homeBreadList = homeBreads();
  homeBreadList.push({ name: NavBarNames.stampCampaigns, link: '/stamp_campaigns' });
  return homeBreadList;
};

export const generalMessageCampaignListBreads = () => {
  const homeBreadList = homeBreads();
  homeBreadList.push({ name: NavBarNames.message, link: '/messages' });

  return homeBreadList;
}

export const createMessageCampaignBreads = (bread) => {
  const camapignListBreadList = generalMessageCampaignListBreads();
  camapignListBreadList.push({
    name: `${bread ? bread : 'Create Message campaign'}`,
    link: '/campaigns/create',
  });
  return camapignListBreadList;
}

export const createStampCampaignBreads = (bread) => {
  const camapignListBreadList = stampCampaignListBreads();
  camapignListBreadList.push({
    name: `${bread ? bread : 'Create Stamp campaign'}`,
    link: '/stamp_campaigns/create',
  });
  return camapignListBreadList;
};

export const editStampCampaignBreads = () => {
  const camapignListBreadList = stampCampaignListBreads();
  camapignListBreadList.push({
    name: 'Edit Campaign',
  });
  return camapignListBreadList;
};
// events 
export const eventsListBreads = () => {
  const homeBreadList = homeBreads();
  homeBreadList.push({ name: 'Events', link: '/events' });
  return homeBreadList;
};

export const createEventBreads = (bread) => {
  const eventListBreadList = eventsListBreads();
  eventListBreadList.push({
    name: `${bread ? bread : 'Create Event'}`,
    link: '/events/create',
  });
  return eventListBreadList;
};

export const editEventBreads = () => {
  const eventListBreadList = eventsListBreads();
  eventListBreadList.push({
    name: 'Edit Event',
  });
  return eventListBreadList;
};

// coupon breadcrumb

export const couponSetBreads = (isTicket=false) => {
  const homeBreadList = homeBreads();
  homeBreadList.push(
    isTicket ? {
      name: NavBarNames.tickets,
      link: '/tickets',
    } : {
      name: NavBarNames.coupons,
      link: '/coupons',
    });
  return homeBreadList;
};

export const createCouponBreads = (id, isTicket) => {
  const couponSetBreadList = couponSetBreads(isTicket);
  couponSetBreadList.push(
    isTicket ? {
      name: `${id ? 'Edit' : 'Create'} Ticket Set`,
      link: '/tickets/create',
    }:
    {
    name: `${id ? 'Edit': 'Create'} Coupon Set`,
    link: '/coupons/create',
  });
  return couponSetBreadList;
};

export const couponSetDetailBreads = (couponSetName, isBack = false, isTicket=false,) => {
  const couponSetListBreadList = couponSetBreads(isTicket);
  couponSetListBreadList.push({
    name: couponSetName,
    link: isTicket ? '/tickets/ticketSet': '/coupons/couponSet',
    isBack: isBack,
  });
  return couponSetListBreadList;
};

export const singleCouponBreads = (couponSetName, singleCouponSerialNum, isTicket=false) => {
  const couponSetDetailBreadList = couponSetDetailBreads(couponSetName, true, isTicket);
  couponSetDetailBreadList.push({
    name: singleCouponSerialNum,
    link: isTicket ? '/tickets/ticketSet/singleTicket': '/coupons/couponSet/singleCoupon',
  });
  return couponSetDetailBreadList;
};
